import React from "react";
import TableSelector from "../../../components/tables/TableSelector";
import compsup from "../../../components/tables/comp-super";
const data = [
  {
    les: "18",
    table: compsup
  }
];

export default () => (
  <TableSelector
    defaultChapter="18"
    data={data}
    title="Comparativus en superlativus"
  />
);



// WEBPACK FOOTER //
// ./src/pages/spqr/rijtjes/comparativus-superlativus.js